module.exports = __webpack_public_path__ + "img/ico-misdatos.5f8b0806.svg";